/* eslint-disable no-console */
// https://www.youtube.com/watch?v=ZiPQSdmcGRk
// https://www.youtube.com/watch?v=1FgSlvsywXg     watch this first
// https://www.youtube.com/watch?v=Ss_YQc7a6Ss
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
// import type { CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthGuard {
    constructor( private authService: AuthService, private router: Router) {
    }

    public async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        console.log('🛡️ AuthGuard: Checking authentication for:', state.url);
        
        // If a current user exists, then the route can be activated
        const user = this.authService.getCurrentUser();
        if (!user) {
            console.log('❌ AuthGuard: Access denied, redirecting to welcome');
            this.router.navigate(['/welcome']);
            return false;
        }

        console.log('✅ Authenticated as: ', user.email);
        return true;
    }
}

/*
This is the old version.

import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
    'providedIn': 'root'
})
export class AuthGuard implements CanActivate {

    constructor( private authService: AuthService) {
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot):
                                    Observable<boolean> | Promise<boolean> | boolean {
        // const loggedIn = false; // replace with actual user auth checking logic
        const loggedIn = this.authService.isAuthenticatedNew();

        loggedIn.then((_loggedIn) => {
            if(!_loggedIn){
                this.router.navigate(['/']);
            }
        });
        // If no one is logged in navigate to the root.
        // if (!loggedIn) {
        //     this.router.navigate(['/']);
        // }
        // } else {
        //     this.router.navigate(['Dashboard']);
        // }

        return loggedIn;
    }
}

*/
